import { default as getkeycode } from "../utility/getkeycode";
import { default as AddFieldValue } from "../utility/addfieldvalue";
import * as LightwindowUtility from "../old-js-dependancies/oldlightwindowutility";

var delay = (function () {
	var timer = null;
	return function (callback, ms) {
		clearTimeout(timer);
		timer = setTimeout(callback, ms);
	};
})();

export function occupation_keyup(e, $elem) {
	var key = getkeycode(e);
	var $nextactive;
	var $curractive = $elem.closest('.js-occupation-wrapper').find('.js-occupation-result .js-occupation-result-item.is-active');
	var val = $curractive.text();

	if (key == 38) { //up arrow
		if ($curractive[0] && $curractive.prev('.js-occupation-result-item:visible')[0]) {
			$curractive.removeClass('is-active');
			$nextactive = $curractive.prev();
		}
		else {
			$nextactive = $elem.closest('.js-occupation-wrapper').find('.js-occupation-result .js-occupation-result-item:visible').last();
		}
		if ($nextactive[0]) $nextactive.addClass('is-active');
	}
	else if (key == 40) { //down arrow
		if ($curractive[0]) $curractive.removeClass('is-active');
		if ($curractive.next('.js-occupation-result-item:visible')[0]) {
			$nextactive = $curractive.next();
		}
		else {
			$nextactive = $elem.closest('.js-occupation-wrapper').find('.js-occupation-result .js-occupation-result-item:visible').first();
		}
		if ($nextactive[0]) $nextactive.addClass('is-active');
	}
	else if (key == 13) { //enter, right arrow
		var client = ($elem.prop('id').indexOf('p2-') == -1 ? 1 : 2);
		if ($elem.closest('.js-occupation-wrapper').find('.js-occupation-result').is(':visible') && $curractive[0]) {
			occupation_fill(client, val);
			$elem.closest('.js-occupation-wrapper').find('.js-occupation-result').hide();
			$(document).unbind('mousedown');
		}
		else {
			occupation_enterpressed = true;
			occupation_search(client, $.trim($elem.val()));
		}
	}
	else if (key == 27) { //escape
		$elem.closest('.js-occupation-wrapper').find('.js-occupation-result').hide();
		$(document).unbind('mousedown');
	}
	else if (key == 8 || (key >= 46 && key <= 90) || (key >= 96 && key <= 111) || (key >= 186 && key <= 222)) { //backspace,delete,numbers,letters,numpad,symbols
		occupation_enterpressed = false;
		if (!occupation_enterpressed) {
			occupation_search(($elem.prop('id').indexOf('p2-') == -1 ? 1 : 2), $.trim($elem.val()));
		}
	}
}

export function occupation_focus(e, $elem) {
	$(document).off('mousedown').on('mousedown', function (event) {
		if (!$(event.target).is('#' + $elem.prop('id')) && !$(event.target).is('.js-occupation-result') && !$(event.target).closest('.js-occupation-result').hasClass('js-occupation-result')) {
			$elem.closest('.js-occupation-wrapper').find('.js-occupation-result').hide();
			$(document).unbind('mousedown');
			$(window).off('.occupation');
		}
	});
}

var occupation_isscrollenabled = true;

export function occupation_setscrollenabled(toggle) {
    occupation_isscrollenabled = toggle;
}

var occupation_enterpressed;
var $occupation_searchcb;

function occupation_search(client, val) {
	if (val.length < 1) {
		$('.js-occupation-result').eq(client - 1).hide();
		return;
	}
	var self = this;
	if ($occupation_searchcb) $occupation_searchcb.abort();
	$occupation_searchcb = $.ajax({
		url: '/api/occupationsearch?searchCriteria=' + val.replace('&', '&amp;'),
		type: 'GET',
		beforeSend: function () {
		},
		contentType: "application/json;charset=utf-8",
		dataType: 'json',
		success: function (res, textStatus, xhr) {
			var wrapper = $('.js-occupation-wrapper[data-person="' + client + '"]');
			var el = wrapper.find('.js-occupation-result');
			if ($(document.activeElement).is('#p' + client + '-occupation')) {
				var htmlTemplate = '<div class="occupation-result-listwrapper js-occupation-result-listwrapper"><div class="occupation-result-list js-occupation-result-list">';
				for (var i = 0; i < res.length; i++) {
					htmlTemplate += '<div class="occupation-result-item js-occupation-result-item" style="display: ' + (i <= 5 ? 'block' : 'none') + '";>' + res[i].occupation + '</div>';
				}
				if (res.length > 5) {
					htmlTemplate += '<a href="javascript:;" class="occupation-result-more js-occupation-result-more"><span class="occupation-result-moreresults">More than 5 results found</span><span class="occupation-result-viewmore">View More</span></a>';
				}
				htmlTemplate += '</div></div>';
				htmlTemplate += '<a href="javascript:;" class="occupation-result-cantfind js-occupation-result-cantfind"><span class="occupation-result-cantfind-text">Can\'t find your occupation ? </span><span class="occupation-result-cantfind-clickhere">Click here</span > </a>';

				el.html(htmlTemplate).show();

                if (occupation_isscrollenabled) {
                    occupation_setmaxheight(el);

                    $(window).on('resize.occupation, scroll.occupation', function () {
                        var windowheight = $(window).height();
                        if ($(window).scrollTop() < $(document).height() - windowheight && $(el)[0].getBoundingClientRect().top > $('.js-siteheader').height() + wrapper.height() + 4) {
                            occupation_setmaxheight(el);
                        }
                    });
                }
			}
			else {
				el.hide();
			}
		},
		error: function (xhr, status, e) {
		}
	});

}

function occupation_setmaxheight(el, delay?) {
	el = el || $(this).closest('.js-occupation-wrapper');
	delay = delay || 0;
	var maxh = $(window).height() - ($(el).offset().top - $(window).scrollTop()) - 64;
	if (maxh <= 0) { maxh = 1; }
	if (maxh > 200) { maxh = 200; }
	setTimeout(function () {
		el.find('.js-occupation-result-listwrapper').css({ 'max-height': maxh });
	}, delay);
}

function occupation_fill(client, val) {
	$('#p' + client + '-occupation').val(val);
	$('.js-occupation-result').eq(client - 1).hide();
}

export function occupation_init() {
	$('.js-occupation-result').on('click', '.js-occupation-result-item', function () {
		var wrapper = $(this).closest('.js-occupation-wrapper');
        occupation_fill(wrapper.data('person'), $(this).text());

        if (occupation_isscrollenabled) {
            let wrapperviewporttop = wrapper.offset().top - $(window).scrollTop();
            if (wrapperviewporttop < $('.js-siteheader').height() + wrapper.height() || wrapperviewporttop > $(window).height() / 2) {
                var ypos = (wrapper.offset().top - $('.js-siteheader').height() - 40);
                $('html, body').animate({ scrollTop: ypos }, 'fast');
            }
        }
	});

	$('.js-occupation-result').on('click', '.js-occupation-result-more', function () {
		$(this).fadeOut('fast', function () {
			$(this).siblings('.js-occupation-result-item').fadeIn('fast');
			occupation_setmaxheight($(this).closest('.js-occupation-wrapper'), 100);
		});
	});

	$('.js-occupation-result').on('click', '.js-occupation-result-cantfind', function (event) {
		event.preventDefault();
		lwoccupationtype_show($(this).closest('.js-occupation-wrapper').data('person'));
	});
}

export function lwoccupationtype_show(client, tocompare?) {
	var panel;
	if ($('.js-occupationtypepanel').length < 1) {
		$.ajax({
			url: '/page_fragments/lightwindow_occupationtype.aspx',
			type: "GET",
			data: '',
			dataType: "html",
			contentType: "application/x-www-form-urlencoded",
			beforeSend: function (xhr) {
				LightwindowUtility.createPopUp('occupationtypepanel');
				panel = $('.js-occupationtypepanel');
				panel.html(LightwindowUtility.lightwindowpreloader);
				LightwindowUtility.showPopUp(panel);
			},
			success: function (res, textStatus, xhr) {
				panel.html(res);
				LightwindowUtility.showPopUp(panel);
				lwoccupationtype_init(panel);
			},
			error: function (xhr, status, e) {
				alert("The data could not be loaded.");
				$('.js-occupationtypepanel').remove();
			}
		});
	} else {
		panel = $('.js-occupationtypepanel');
		LightwindowUtility.showPopUp(panel);
		$('.js-occupationtypepanel-oc').prop('checked', false);
		lwoccupationtype_init(panel);
	}

	function lwoccupationtype_init(panel?) {
		panel.find('.js-lightwindow-submit').off('click').on('click', function (event) {
			event.preventDefault();
			var selectedclass = panel.find('input[name="occupationtypepanel-oc"]:checked').val();
			$('#p' + client + '-occupation').val(selectedclass).trigger('change');
			LightwindowUtility.closePopUp(panel);
		});
		panel.find('.js-lightwindow-cancel').off('click').on('click', function (event) {
			event.preventDefault();
			LightwindowUtility.closePopUp(panel);
		});
	}
}